import { IAuditState } from "./AuditState";

export const initState: IAuditState = {
    auditList: {
        audits: [],
        operators: [],
        isReceivingAudits: false,
        auditTags: []
    }
}